import classnames from 'classnames'
import React from 'react';
import * as ReactStrap from 'reactstrap';
import './styles.css'

interface Props {
  className?: string,
  disabled?: boolean,
  labelstyle?: string,
  initializeOpen?: boolean,
  label: string,
}

interface State {
  labelstyle: string,
  isOpen: boolean,
}

export class RasaCollapse extends React.Component<Props, State> {
  // This class exists because as of July, 2018 - UncontrolledCollapse was not
  // yet included in ReactStrap types.  If/when its included - uses of RasaCollapse
  // can most likely be replaced entirely with UncontrolledCollapse.

  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: props.initializeOpen || false,
      labelstyle: props.labelstyle || 'collapse-label',
    };
  }

  public toggle = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  public render() {
    const {initializeOpen, ...localProps} = this.props
    return (
      <div className={classnames(`collapse-${this.state.isOpen}`, this.props.className,
        {'rasa-collapse-disabled': this.props.disabled})}>
        <div className="collapse-handle">
          <ReactStrap.Button className="collapse-btn" onClick={this.toggle} disabled={this.props.disabled}>
            <i className="fa fa-caret-right"/>
          </ReactStrap.Button>
          <span className={this.state.labelstyle} onClick={this.toggle}>{this.props.label}</span>
        </div>
        <ReactStrap.Collapse isOpen={this.state.isOpen && !this.props.disabled} {...localProps} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/rasa-input/collapse.tsx